module.exports = __webpack_public_path__ + "public/static/img/img-section5-02.5616043.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-section5-02.svg
// module id = tAIQ
// module chunks = 1